export enum FontLocation {
  TITLE = 'title',
  HEADING = 'heading',
  BODY = 'body',
}
